import { createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';

const initialState = false;

const setIsCompatible = (_, { payload: isCompatible }) => isCompatible ?? false;

export default createReducer(initialState, {
  [types.SET_BROWSER_NOTIFICATION_COMPATIBILITY]: setIsCompatible,
});
